// Generated from backend/VERSION by scripts/versioning.py; do not edit.
export const APP_VERSION = '1.5.1';
